<template>
  <div v-show="visible" class="modal__getArhive">
    <div class="modal-content">
      <div class="modal-header">
        <h3></h3>
        <button type="button" class="close popap__btn-close" @click="hide">
          <i><img src="/img/ic_close_chip.svg" alt=""></i>
        </button>
      </div>
      <div class="modal-body" style="min-height: 600px; min-width: 800px">
        <iframe style="width:100%; height: 550px" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" :src="getUrl()"></iframe>
      </div>
    </div>
    <div class="modal-backdrop show" @click="hide"></div>
  </div>
</template>

<script>

export default {
  name: "photo-360-modal",
  components: {},
  props: {
    reference: {
      require: true
    }
  },
  data: () => ({
    visible: false
  }),
  created() {
  },
  mounted() {
    this.$root.$on('photo-360-modal::show', this.show)
  },
  methods: {
    show() {
      document.body.classList.add('modal-open')
      this.visible = true
    },
    hide() {
      document.body.classList.remove('modal-open')
      this.visible = false
      this.$root.$emit('photo-360-modal::hide')
    },
    getUrl() {
      return process.env.VUE_APP_API_URL + '/player/embed/' + this.reference
    }
  }
}
</script>

